import { render } from "./ViewHeader.vue?vue&type=template&id=790473dd&scoped=true&ts=true"
import script from "./ViewHeader.vue?vue&type=script&lang=ts"
export * from "./ViewHeader.vue?vue&type=script&lang=ts"

import "./ViewHeader.vue?vue&type=style&index=0&id=790473dd&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution.Cashier/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790473dd"]])

export default __exports__